(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-ad-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.bmLandingEventsBound) return;
  window.bmLandingEventsBound = true;
document.addEventListener('change', event => {
  if (!event.target.matches('[data-bml-variant]')) return;
  const option = event.target;
  const form = option.closest('form');
  form.querySelector('[data-bml-price]').textContent = option.dataset.price;
  const section = form.closest('.bml');
  if (form.getAttribute('id') !== section.dataset.bmlMainForm) return;
  section.querySelectorAll('[data-bml-selected-price]').forEach(node => { node.textContent = option.dataset.price; });
  section.querySelectorAll('[data-bml-selected-title]').forEach(node => { if (option.dataset.name) node.textContent = option.dataset.name; });
  section.querySelectorAll('[data-bml-selected-name]').forEach(node => { node.textContent = option.dataset.name ? option.dataset.name + ' · ' : ''; });
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('.bml-buy form')) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button.disabled) return;
  const error = form.querySelector('[data-bml-error]');
  const fallbackError = error.textContent;
  error.hidden = true;
  const buttons = [button, ...document.querySelectorAll('button[form="' + form.getAttribute('id') + '"]')];
  buttons.forEach(control => { control.disabled = true; });
  button.setAttribute('aria-busy', 'true');
  drawer.setActiveElement(button);
  let added = false;
  try {
    const data = new FormData(form);
    data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.append('sections_url', window.location.pathname);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || fallbackError);
    added = true;
    drawer.renderContents(state);
  } catch (failure) {
    if (added) {
      // Never retry an accepted add: a rendering failure must not duplicate it.
      window.location.assign(window.Shopify.routes.root + 'cart');
      return;
    }
    error.textContent = failure.message || fallbackError;
    error.hidden = false;
  } finally {
    buttons.forEach(control => { control.disabled = false; });
    button.removeAttribute('aria-busy');
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-early-promo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bm-early-promo')) {
  customElements.define('bm-early-promo', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const button = this.querySelector('button');
      const label = button.querySelector('strong');
      const status = this.querySelector('[role="status"]');
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          label.textContent = this.dataset.copied;
          status.textContent = this.dataset.copied;
          clearTimeout(this.resetLabel);
          this.resetLabel = setTimeout(() => { label.textContent = this.dataset.code; }, 2000);
        } catch (_) {
          status.classList.remove('visually-hidden');
          status.textContent = this.dataset.copyError.replace('[code]', this.dataset.code);
        }
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; clearTimeout(this.resetLabel); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-routine-builder"] && !Shopify.designMode) return;
  try {
    
function bmRoutineQuote(items) {
  const subtotal = items.reduce((sum, item) => sum + item.price, 0);
  const minimum = items.length ? Math.min(...items.map(item => item.price)) : 0;
  const discount = items.length === 3 ? minimum : items.length === 2 ? Math.floor(minimum / 2) : 0;
  const total = subtotal - discount;
  return { subtotal, discount, total, saving: discount, rewardIndex: items.findIndex(item => item.price === minimum) };
}
if (!customElements.get('bm-routine-builder')) {
  customElements.define('bm-routine-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.selection = []; this.target = 2; this.upselling = false; this.previous = null; this.busy = false;
      this.cards = [...this.querySelectorAll('[data-product]')];
      this.products = new Map(this.cards.map(card => [card.dataset.product, {
        id: card.dataset.product, sku: card.dataset.sku, price: Number(card.dataset.price), title: card.dataset.title,
        available: card.dataset.available === 'true', image: card.querySelector('img').currentSrc || card.querySelector('img').src,
        alt: card.querySelector('img').alt, description: card.querySelector('[data-description]').content.textContent.trim(),
        size: card.querySelector('.bmrb-card__size').textContent, url: card.dataset.url, card
      }]));
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.summary = this.querySelector('.bmrb-summary');
      this.storageKey = 'blackmask-routine-2026-' + this.dataset.currency;
      this.pendingKey = this.storageKey + '-pending';
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.offer = window.BMRoutineOffer;
      this.units = [];
      try {
        this.pending = JSON.parse(sessionStorage.getItem(this.pendingKey) || 'null');
      } catch (_) {}
      if (this.pending?.action === 'set') this.persistPending(null);
      document.addEventListener('bm:routine-cart', event => {
        if (!this.busy) {this.applyCart(event.detail.cart);this.render();}
      }, {signal:this.controller.signal});
      this.addEventListener('click', event => this.onClick(event), { signal: this.controller.signal });
      document.addEventListener('keydown', event => this.onKeydown(event), { signal: this.controller.signal });
      window.addEventListener('pageshow',event=>{if(event.persisted){this.busy=false;this.hydrate(true);}}, {signal:this.controller.signal});
      this.media = window.matchMedia('(min-width: 990px)');
      this.media.addEventListener('change', () => { if (this.media.matches) this.closeSummary(); }, { signal: this.controller.signal });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } }, { signal: this.controller.signal });
      });
      this.observer = new IntersectionObserver(entries => { this.builderVisible = entries[0].isIntersecting; this.toggleDock(); }, { threshold: 0 });
      this.observer.observe(this.querySelector('.bmrb-grid'));
      this.hydrate();
    }
    disconnectedCallback() { this.closeSummary(); this.controller?.abort(); this.controller = null; this.observer?.disconnect(); clearTimeout(this.toastTimer); }
    t(key, replacements = {}) { let value = this.strings[key] || key; for (const [token, text] of Object.entries(replacements)) value = value.replaceAll('[' + token + ']', String(text)); return value; }
    format(cents) { return this.money.format(cents / 100); }
    items() { return this.selection.map(id => this.products.get(id)).filter(Boolean); }
    quote(ids = this.selection) { return bmRoutineQuote(ids.map(id => this.products.get(id)).filter(Boolean)); }
    el(tag, className, content) { const element = document.createElement(tag); if (className) element.className = className; if (content !== undefined) element.textContent = content; return element; }
    icon(name) {
      const paths = {"arrow":"M4 12h16m-6-6 6 6-6 6","diagonal":"M6 18 18 6M6 6h12v12","down":"M12 4v16m-6-6 6 6 6-6","chevron":"m6 15 6-6 6 6","check":"m5 12 4 4L19 6","plus":"M12 5v14M5 12h14","minus":"M5 12h14","close":"m6 6 12 12M18 6 6 18","gift":"M4 10h16v10H4zM3 6h18v4H3zM12 6v14M12 6H8a2 2 0 1 1 2-2l2 2Zm0 0h4a2 2 0 1 0-2-2l-2 2Z"};
      const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
      for(const [key,value] of Object.entries({class:'bmrb-icon',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.6','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(key,value);
      path.setAttribute('d',paths[name]||paths.plus);svg.append(path);return svg;
    }
    image(item) { const img = this.el('img'); img.src = item.image; img.alt = item.title; img.width = 44; img.height = 46; img.loading = 'lazy'; return img; }
    toggleDock() { this.classList.toggle('is-building', Boolean(this.builderVisible || this.selection.length)); }
    savePrevious() { this.previous = { selection: this.selection.slice(), target: this.target }; }
    onClick(event) {
      const button = event.target.closest('button, a[data-terms-link]');
      if (!button || !this.contains(button)) return;
      if (button.matches('[data-upgrade]')) {this.upselling=true;this.closeSummary();this.render(true);this.chooseNext();return;}
      if (button.matches('[data-filter]')) {
        this.querySelectorAll('[data-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        this.cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.group !== button.dataset.filter; }); return;
      }
      if (button.matches('[data-quick]')) return this.openQuick(button.dataset.quick);
      if (this.busy) return;
      if (button.matches('[data-add]')) return this.add(button.dataset.add);
      if (button.matches('[data-quick-add]')) { this.querySelector('[data-quick-dialog]').close(); return this.add(this.quickId); }
      if (button.matches('[data-decrease]')) return this.removePick(this.selection.lastIndexOf(button.dataset.decrease));
      if (button.matches('[data-remove]')) return this.removePick(Number(button.dataset.remove));
      if (button.matches('[data-preset]')) return this.addPreset(button.dataset.preset);
      if (button.matches('[data-clear]')) return this.clearPicks();
      if (button.matches('[data-open-summary]')) return this.openSummary();
      if (button.matches('[data-close-summary], [data-scrim], [data-terms-link]')) return this.closeSummary();
      if (button.matches('[data-close-dialog]')) return button.closest('dialog').close();
      if (button.matches('[data-checkout-button], [data-mobile-cta]')) { if (this.selection.length >= 2) return this.checkout(); this.closeSummary(); this.chooseNext(); }
    }
    chooseNext() {
      this.cards.find(card => !card.hidden && card.dataset.available === 'true')?.querySelector('[data-add]')?.focus({ preventScroll: true });
      this.querySelector('.bmrb-selection-guide').scrollIntoView({ behavior: 'instant', block: 'start' });
    }
    upgradeMinimum() {
      if (this.selection.length !== 2) return 0;
      const costs = [...this.products.values()].filter(item=>item.available).map(item=>this.quote([...this.selection,item.id]).total-this.quote().total);
      return costs.length ? Math.min(...costs) : 0;
    }
    upgradeSavingsMaximum() {
      if(this.selection.length!==2)return 0;
      const savings=[...this.products.values()].filter(item=>item.available).map(item=>this.quote([...this.selection,item.id]).saving);
      return savings.length?Math.max(...savings):0;
    }
    render(announce = false) {
      const items=this.items(),quote=this.quote(),count=items.length,complete=count>=3,pair=count===2;
      this.target=complete?3:2;
      const ready=count>=2, minimum=this.upgradeMinimum(), maxSaving=this.upgradeSavingsMaximum();
      this.dataset.stage=complete?'trio':pair?'pair':'building';
      this.classList.toggle('is-upselling',pair&&this.upselling);
      const status=this.t(complete?'trio_ready':pair?'pair_ready':count?'one_to_go':'start_with_two');
      const label=this.t(this.loading?'loading_cart':this.busy?'offer_syncing':complete?'checkout_three':pair?'checkout_two':count?'choose_second_cta':'empty_cta');
      const saving=this.t('saving_label',{amount:this.format(quote.saving)});
      this.querySelector('[data-count]').textContent=count+' / '+this.target;
      this.querySelector('[data-guide]').textContent=this.t(complete?'builder_trio':pair?'builder_pair':count?'builder_one':'builder_empty');
      this.querySelector('[data-tier-pair]').textContent=pair?saving:this.t('tier_pair_detail');
      this.querySelector('[data-tier-trio]').textContent=complete?saving:pair?this.t('upgrade_from',{amount:this.format(maxSaving)}):this.t('tier_trio_detail');
      this.querySelector('[data-nudge]').textContent=quote.saving?saving:this.t(count?'one_to_go':'pair_reward');
      const slots=this.querySelector('[data-slots]');slots.replaceChildren();
      for(let i=0;i<3;i++){
        const item=items[i],optional=!item&&i===2;
        const slot=this.el('div','bmrb-slot'+(item?'':' bmrb-slot--empty')+(optional?' bmrb-slot--optional':''));
        if(!item){
          slot.append(optional?this.icon('gift'):this.el('span','bmrb-slot__number','0'+(i+1)),this.el('p','',this.t(optional?'optional_third':i?'second_pick':'first_pick')));
        }else{
          const body=this.el('div','bmrb-slot__body'),prices=this.el('div','bmrb-slot__prices');body.append(this.el('p','',item.title));
          const rewarded=count>1&&i===quote.rewardIndex;
          if(rewarded)prices.append(this.el('s','',this.format(item.price)),this.el('span','',complete?this.t('free'):this.format(item.price-quote.discount)));
          else prices.append(this.el('span','',this.format(item.price)));
          body.append(prices);
          const remove=this.el('button','bmrb-slot__remove');remove.append(this.icon('close'));remove.type='button';remove.dataset.remove=i;remove.setAttribute('aria-label',this.t('remove',{title:item.title}));remove.disabled=this.busy;
          slot.append(this.image(item),body,remove);
        }
        slots.append(slot);
      }
      const minis=this.querySelector('[data-mini-slots]');minis.replaceChildren();
      for(let i=0;i<3;i++){
        const item=items[i],mini=this.el('button','bmrb-minipick'+(item?' is-filled':'')+(i===2&&!item?' is-optional':''));mini.type='button';
        if(item){mini.dataset.openSummary='';mini.setAttribute('aria-label',this.t('edit_item',{title:item.title}));mini.append(this.image(item));}
        else{mini.dataset[pair&&i===2?'upgrade':'openSummary']='';mini.setAttribute('aria-label',this.t(i===2?'upgrade_cta':'edit'));mini.append(i===2?this.icon('gift'):this.el('span','',String(i+1)));}
        if(i===2&&!item)mini.append(this.el('small','',this.t('optional_short')));
        mini.disabled=this.busy;minis.append(mini);
      }
      this.querySelectorAll('[data-subtotal],[data-mobile-subtotal]').forEach(el=>{el.textContent=this.format(quote.subtotal);el.hidden=!quote.saving;});
      this.querySelector('[data-total]').textContent=count?this.format(quote.total):'—';
      this.querySelector('[data-mobile-total]').textContent=count?this.format(quote.total):'—';
      this.querySelector('[data-mobile-title]').textContent=ready?this.t(complete?'trio_saved':'pair_saved',{amount:this.format(quote.saving)}):status;
      this.querySelector('[data-mobile-reward]').textContent=ready?this.t('upgrade_reward'):this.t(count?'pair_reward':'pair_intro');
      this.querySelector('[data-mobile-nudge]').textContent=pair?this.t('tray_third_prompt'):complete?this.t('ready_checkout'):this.t(count?'tray_second_prompt':'tray_start_prompt');
      this.querySelector('[data-checkout-label]').textContent=label;this.querySelector('[data-mobile-label]').textContent=label;
      this.querySelectorAll('[data-checkout-button],[data-mobile-cta]').forEach(el=>{el.disabled=this.busy;});
      this.querySelectorAll('[data-upgrade]').forEach(el=>{el.hidden=!pair;el.disabled=this.busy;});
      this.querySelector('[data-upgrade-note]').hidden=!pair;
      this.querySelector('[data-upgrade-note]').textContent=this.t('upgrade_note',{amount:this.format(minimum),saving:this.format(maxSaving)});
      this.querySelector('[data-clear]').textContent=this.t('clear_cart');this.querySelector('[data-clear]').hidden=!count;this.querySelector('[data-clear]').disabled=this.busy;
      this.querySelectorAll('[data-preset]').forEach(el=>{el.disabled=this.busy;});
      this.cards.forEach(card=>{
        const item=this.products.get(card.dataset.product),quantity=this.selection.filter(id=>id===item.id).length;
        card.classList.toggle('is-selected',quantity>0);card.querySelector('.bmrb-card__chosen').hidden=!quantity;
        card.querySelector('[data-card-count]').textContent=this.t('in_routine',{count:quantity});
        const add=card.querySelector('[data-add]');add.disabled=!item.available||complete||this.busy;
        const adding=this.busy&&this.activePick===item.id;
        card.classList.toggle('is-pending',adding);
        add.setAttribute('aria-label',this.t(pair?'third_aria':quantity?'add_another':'add_title',{title:item.title}));
        add.replaceChildren(document.createTextNode(this.t(!item.available?'unavailable':adding?'adding':complete?(quantity?'added':'full'):pair?'add_third':'add')),...(complete||adding||!item.available?[]:[this.icon('plus')]));
        const next=card.querySelector('[data-next-cost]'),preview=(pair||count===1)&&item.available;
        next.hidden=!preview;card.classList.toggle('has-quote',preview);
        next.replaceChildren();
        if(preview){
          const nextQuote=this.quote([...this.selection,item.id]);
          const prices=this.el('span','bmrb-card__quote-prices');
          prices.append(this.el('strong','',this.format(nextQuote.total)),this.el('s','',this.format(nextQuote.subtotal)));
          next.append(this.el('span','bmrb-card__quote-label',this.t(pair?'card_trio_total':'card_pair_total')),prices,this.el('span','bmrb-card__quote-saving',this.t(pair?'card_bundle_saving':'card_pair_saving',{amount:this.format(nextQuote.saving)})));
        }
        const decrease=card.querySelector('[data-decrease]');decrease.hidden=!quantity;decrease.disabled=this.busy;
      });
      this.toggleDock();this.setAttribute('aria-busy',String(this.busy));
      if(announce)this.announce(status+'. '+this.t('total')+' '+this.format(quote.total)+'. '+(pair?this.t('pair_choice_note'):quote.saving?saving:''));
    }
    announce(text) { this.querySelector('[data-live]').textContent = text; }
    showToast(message, error = false) { this.querySelector('[data-undo]').hidden = true; this.querySelector('[data-toast]').textContent = message; this.querySelector('.bmrb-toast').hidden = false; clearTimeout(this.toastTimer); if (!error) this.toastTimer = setTimeout(() => { this.querySelector('.bmrb-toast').hidden = true; },7000); }
    openQuick(id) {
      const item = this.products.get(id); if (!item) return; this.quickId = id;
      const dialog = this.querySelector('[data-quick-dialog]'), image = dialog.querySelector('[data-quick-image]'); image.src = item.image; image.alt = item.title;
      dialog.querySelector('[data-quick-size]').textContent = item.size; dialog.querySelector('[data-quick-title]').textContent = item.title; dialog.querySelector('[data-quick-description]').textContent = item.description; dialog.querySelector('[data-quick-price]').textContent = this.format(item.price); dialog.querySelector('[data-quick-link]').href = item.url;
      const add = dialog.querySelector('[data-quick-add]'); add.disabled = this.busy || !item.available || this.selection.length >= 3; add.textContent = this.t(!item.available ? 'unavailable' : this.selection.length >= 3 ? 'full' : this.selection.length === 2 ? 'add_third' : 'choose'); dialog.showModal();
    }
    openSummary() { if (this.media.matches) return; this.summaryOpener = document.activeElement; this.summary.classList.add('is-open'); this.summary.setAttribute('role','dialog'); this.summary.setAttribute('aria-modal','true'); this.querySelector('[data-scrim]').hidden = false; this.previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; this.querySelector('[data-scrim]').onclick = () => this.closeSummary(); this.querySelector('[data-close-summary]').focus(); }
    closeSummary() { if (!this.summary?.classList.contains('is-open')) return; this.summary.classList.remove('is-open'); this.summary.removeAttribute('role'); this.summary.removeAttribute('aria-modal'); this.querySelector('[data-scrim]').hidden = true; document.body.style.overflow = this.previousOverflow || ''; this.summaryOpener?.focus({preventScroll:true}); }
    onKeydown(event) {
      if (!this.summary?.classList.contains('is-open') || this.querySelector('dialog[open]')) return;
      if (event.key === 'Escape') {event.preventDefault();this.closeSummary();}
      if (event.key === 'Tab') { const f=[...this.summary.querySelectorAll('button:not(:disabled),a[href]')].filter(el=>!el.hidden&&el.offsetParent!==null),first=f[0],last=f[f.length-1]; if (!this.summary.contains(document.activeElement) || (!event.shiftKey&&document.activeElement===last)) {event.preventDefault();first.focus();} else if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();} }
    }
    applyCart(cart) {
      this.nativeCart = cart;
      this.units = this.offer.eligibleItems(cart).flatMap(line => Array.from({length:line.quantity},()=>({id:String(line.variant_id),key:line.key,properties:line.properties || {}}))).filter(unit=>this.products.has(unit.id));
      this.target=this.units.length>=3?3:2;
      this.selection=this.units.slice(0,3).map(unit=>unit.id);
      if(this.selection.length!==2)this.upselling=false;
    }
    async hydrate(fresh = false) {
      this.busy = true; this.loading = true; this.render();
      try {
        const initial = await this.offer.currentCart({fresh});
        this.applyCart(initial); this.render();
        const cart = await this.offer.sync({cart:initial});
        this.applyCart(cart); this.offer.render(cart);
      } catch (_) { this.showToast(this.t('cart_load_error'),true); }
      finally {this.busy = false; this.loading = false; this.render();}
    }
    persistPending(value) {
      this.pending = value;
      try {if (value) sessionStorage.setItem(this.pendingKey,JSON.stringify(value)); else sessionStorage.removeItem(this.pendingKey);} catch (_) {}
    }
    async runCart(action) {
      if (this.busy) return;
      const started = Date.now();
      this.busy = true; this.querySelector('.bmrb-toast').hidden = true; this.render();
      try {await action();}
      catch (error) {
        try {this.applyCart(await this.offer.getCart());} catch (_) {}
        this.announce(error.message || this.t('checkout_error'));
        this.showToast(error.message || this.t('checkout_error'),true);
      } finally {this.busy = false; this.activePick = null; this.dataset.cartDurationMs = String(Date.now()-started); this.render();}
    }
    async refreshCart(cart, open = false, prepared = false) {
      const sections = !prepared || this.offer.count(cart) >= 3 || open ? ['cart-drawer','cart-icon-bubble','bm-routine-cart-state'] : ['cart-icon-bubble','bm-routine-cart-state'];
      cart = await this.offer.sync({cart,sections,force:!prepared,reuseSections:prepared});
      this.applyCart(cart); this.offer.render(cart,open); return cart;
    }
    add(id) {
      if (!this.products.get(id)?.available || this.selection.length >= 3) return;
      this.activePick = id;
      return this.runCart(async () => {
        let cart = await this.offer.currentCart({fresh:Boolean(this.pending)});
        this.applyCart(cart);
        if (this.selection.length >= 3) {await this.finish(cart);return;}
        if (!this.pending || this.pending.action !== 'add' || this.pending.id !== id) this.persistPending({action:'add',id,token:crypto.randomUUID()});
        let prepared = false;
        if (!cart.items.some(line=>line.properties?._bm_routine === this.pending.token)) {
          const sections = this.selection.length >= 2 ? ['cart-drawer','cart-icon-bubble','bm-routine-cart-state'] : ['cart-icon-bubble','bm-routine-cart-state'];
          const added = await this.offer.request('cart/add.js',{items:[{id,quantity:1,properties:{_bm_routine:this.pending.token}}],sections,sections_url:window.location.pathname});
          const renderedCart = this.offer.cartFromSections?.(added,cart);
          if (renderedCart) {cart = renderedCart; prepared = true;}
          else if (Number.isFinite(added.item_count)) cart = added;
          else {
            const lines = (added.items || []).filter(line=>line.properties?._bm_routine === this.pending.token);
            if (!lines.length) cart = await this.offer.getCart();
            else cart = {...cart,sections:undefined,items:[...cart.items.filter(line=>!lines.some(addedLine=>addedLine.key===line.key)),...lines]};
          }
          this.applyCart(cart); this.render();
        }
        cart = await this.refreshCart(cart,false,prepared);
        this.persistPending(null);
        if (this.selection.length >= 3) await this.finish(cart,'cart',true);
        else if(this.selection.length===2){this.upselling=false;this.announce(this.t('pair_ready')+'. '+this.t('pair_choice_note'));}
      });
    }
    removePick(index) {
      const unit = this.units[index]; if (!unit) return;
      return this.runCart(async () => {
        let cart = await this.offer.getCart();
        const line = this.offer.eligibleItems(cart).find(item=>item.key === unit.key) || this.offer.eligibleItems(cart).find(item=>String(item.variant_id)===unit.id && JSON.stringify(item.properties || {})===JSON.stringify(unit.properties));
        if (!line) throw new Error(this.t('cart_changed'));
        cart = await this.offer.request('cart/change.js',{id:line.key,quantity:line.quantity-1});
        this.persistPending(null); await this.refreshCart(cart);
      });
    }
    clearPicks() {
      const units = this.units.slice(0,this.target);
      return this.runCart(async () => {
        let cart = await this.offer.getCart(), updates = {};
        for (const unit of units) {
          const line = this.offer.eligibleItems(cart).find(item=>item.key===unit.key) || this.offer.eligibleItems(cart).find(item=>String(item.variant_id)===unit.id && JSON.stringify(item.properties || {})===JSON.stringify(unit.properties));
          if (line) updates[line.key] = Math.max(0,(updates[line.key] ?? line.quantity)-1);
        }
        if (Object.keys(updates).length) cart = await this.offer.request('cart/update.js',{updates});
        this.persistPending(null); await this.refreshCart(cart);
      });
    }
    async finish(cart, destination = 'cart', prepared = false) {
      const quote = this.quote();
      const onlyPicks = this.offer.eligibleItems(cart).length === cart.items.length && this.offer.count(cart) === this.selection.length;
      if (!prepared) cart = await this.refreshCart(cart);
      if (onlyPicks && cart.total_price > quote.total) throw new Error(this.t('discount_error'));
      this.persistPending(null); this.closeSummary();
      if(destination==='checkout')this.navigateCheckout();else this.offer.render(cart,true);
    }
    navigateCheckout() {window.location.assign((this.dataset.root || '/')+'checkout');}
    checkout() {
      return this.runCart(async () => {
        const cart = await this.offer.getCart(); this.applyCart(cart);
        if (this.selection.length >= 2) await this.finish(await this.offer.sync({cart}),'checkout',true);
        else {await this.refreshCart(cart);this.chooseNext();}
      });
    }
    addPreset(skus) {
      const picks = skus.split(',').map(sku=>[...this.products.values()].find(item=>item.sku===sku && item.available));
      if (picks.some(item=>!item)) return this.announce(this.t('unavailable'));
      return this.runCart(async () => {
        let cart = await this.offer.getCart();
        const signature = picks.map(item=>item.id).sort().join('|');
        if (!this.pending || this.pending.action!=='preset' || this.pending.signature!==signature) this.persistPending({action:'preset',signature,token:crypto.randomUUID()});
        const wanted = [...new Set(picks.map(item=>item.id))].map(id=>({id,quantity:picks.filter(item=>item.id===id).length}));
        const existing = cart.items.filter(line=>line.properties?._bm_routine===this.pending.token);
        const missing = wanted.map(item=>({...item,quantity:item.quantity-existing.filter(line=>String(line.variant_id)===String(item.id)).reduce((n,line)=>n+line.quantity,0),properties:{_bm_routine:this.pending.token}})).filter(item=>item.quantity>0);
        if (missing.length) await this.offer.request('cart/add.js',{items:missing});
        cart = await this.refreshCart();this.persistPending(null);this.closeSummary();this.offer.render(cart,true);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-style-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.bmLandingEventsBound) return;
  window.bmLandingEventsBound = true;

document.addEventListener('change', event => {
  if (!event.target.matches('[data-bml-variant]')) return;
  const option = event.target;
  const form = option.closest('form');
  form.querySelector('[data-bml-price]').textContent = option.dataset.price;
  const section = form.closest('.bml');
  if (form.getAttribute('id') !== section.dataset.bmlMainForm) return;
  section.querySelectorAll('[data-bml-selected-price]').forEach(node => { node.textContent = option.dataset.price; });
  section.querySelectorAll('[data-bml-selected-title]').forEach(node => { if (option.dataset.name) node.textContent = option.dataset.name; });
  section.querySelectorAll('[data-bml-selected-name]').forEach(node => { node.textContent = option.dataset.name ? option.dataset.name + ' · ' : ''; });
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('.bml-buy form')) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button.disabled) return;
  const error = form.querySelector('[data-bml-error]');
  const fallbackError = error.textContent;
  error.hidden = true;
  const buttons = [button, ...document.querySelectorAll('button[form="' + form.getAttribute('id') + '"]')];
  buttons.forEach(control => { control.disabled = true; });
  button.setAttribute('aria-busy', 'true');
  drawer.setActiveElement(button);
  let added = false;
  try {
    const data = new FormData(form);
    data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.append('sections_url', window.location.pathname);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || fallbackError);
    added = true;
    drawer.renderContents(state);
  } catch (failure) {
    if (added) {
      // Never retry an accepted add: a rendering failure must not duplicate it.
      window.location.assign(window.Shopify.routes.root + 'cart');
      return;
    }
    error.textContent = failure.message || fallbackError;
    error.hidden = false;
  } finally {
    buttons.forEach(control => { control.disabled = false; });
    button.removeAttribute('aria-busy');
  }
});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-finish"] && !Shopify.designMode) return;
  try {
    
function initBlackMaskFinish(root) {
  root.querySelectorAll('.bm-finish').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    section.addEventListener('click', event => {
      const button = event.target.closest('[data-bm-filter]');
      if (!button) return;
      const filter = button.dataset.bmFilter;
      const update = () => {
        section.querySelectorAll('[data-bm-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelectorAll('[data-bm-card]').forEach(card => card.hidden = filter !== 'all' && !card.dataset.bmFinishes.split(' ').includes(filter));
        section.querySelector('[data-bm-filter-status]').textContent = button.textContent;
      };
      if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update); else update();
    });
  });
}
initBlackMaskFinish(document);
document.addEventListener('shopify:section:load', event => initBlackMaskFinish(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bm-native-film')) {
  customElements.define('bm-native-film', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const error = this.querySelector('[role="status"]');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const sync = () => {
        button.setAttribute('aria-label', video.paused ? 'Play styling video' : 'Pause styling video');
        button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
      };
      button.addEventListener('click', async () => {
        error.hidden = true;
        if (!video.paused) { video.pause(); return; }
        try { await video.play(); } catch (_) { error.hidden = false; }
      }, options);
      video.addEventListener('play', sync, options);
      video.addEventListener('pause', sync, options);
      video.addEventListener('error', () => { error.hidden = false; sync(); }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); }, options);
      const observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); });
      observer.observe(this);
      this.cleanup = () => { video.pause(); observer.disconnect(); controller.abort(); };
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
  });
}

if (!customElements.get('bm-hero-film')) {
  customElements.define('bm-hero-film', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const opener = this.querySelector('.bm-film__cover');
      const dialog = this.querySelector('dialog');
      const video = dialog.querySelector('video');
      const embed = dialog.querySelector('iframe');
      opener.addEventListener('click', () => {
        dialog.showModal();
        if (embed) embed.src = embed.dataset.src;
        if (video) video.play().catch(() => {});
      });
      this.querySelector('.bm-film__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { if (video) video.pause(); if (embed) embed.removeAttribute('src'); opener.focus({preventScroll:true}); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onPageShowHandler = () => {
        this.syncSurface();
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        cancelAnimationFrame(this.restoreFrame);
        // History restoration can finish after pageshow; read again before paint.
        this.restoreFrame = requestAnimationFrame(() => {
          this.syncSurface();
          this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        });
      };
      this.onPageHideHandler = () => {
        cancelAnimationFrame(this.restoreFrame);
        this.header.classList.remove('bm-nav-at-top');
      };
      this.enableScroll();
      window.addEventListener('pageshow', this.onPageShowHandler);
      window.addEventListener('pagehide', this.onPageHideHandler);
      this.onPageShowHandler();
    }

    disconnectedCallback() {
      this.disableScroll();
      window.removeEventListener('pageshow', this.onPageShowHandler);
      window.removeEventListener('pagehide', this.onPageHideHandler);
      cancelAnimationFrame(this.restoreFrame);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    syncSurface(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      this.header.classList.toggle('bm-nav-scrolled', scrollTop > 8);
      this.header.classList.toggle('bm-nav-at-top', scrollTop <= 8);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.toggle('shopify-section-header-sticky', scrollTop >= this.header.offsetHeight);
      }
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.syncSurface(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
